/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState } from 'react';

import { useDataModel, QueryProvider } from '@thd-nucleus/data-sources';
import { PlccDrawerContentDataModel, PlccPromoInfoDataModel } from '../contentful/dataModel/dataModel';

const ContentfulContext = createContext();

export const useContentfulContext = () => {
  return useContext(ContentfulContext);
};

export const ContentfulProvider = ({ children }) => {
  const [state, setState] = useState({});

  const { data: plccDrawerData = {}, error: plccDrawerDataError = null } = useDataModel('component', {
    variables: { id: 'GYuwVyFrBbvMmYoyMZdl6' },
    dataModel: PlccDrawerContentDataModel,
  });

  const { data: plccData = {}, error: plccDataError = null } = useDataModel('component', {
    variables: { id: '2mf1i1OmapsjB3PCzwGynI' },
    dataModel: PlccPromoInfoDataModel,
  });

  const updateState = (newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  };

  if (plccDrawerDataError || plccDataError) {
    console.error('Error fetching contentful data.');
  }

  return (
    <ContentfulContext.Provider
      value={{
        state,
        updateState,
        plccDrawerData,
        plccDrawerDataError,
        plccData,
      }}
    >
      <QueryProvider cacheKey="context-query-provider">
        {children}
      </QueryProvider>
    </ContentfulContext.Provider>
  );
};
